/**
 * Quebra o que a pessoa digitou num campo de "vários itens" em itens.
 *
 * O separador é `;` e SÓ ele: vírgula pode fazer parte de um termo
 * ("Banco do Brasil, agência Centro"), e `;` já é a convenção do
 * onboarding (`splitList`) e a forma como o banco guarda listas
 * (`name_variations`, citation tags) — o servidor recusa tag com `;`
 * dentro justamente por isso.
 *
 * Tira espaços das pontas, descarta vazios (`a;;b`, `a;` no fim) e
 * remove repetidos mantendo a ordem da primeira ocorrência. A
 * comparação de repetido é exata (maiúscula e minúscula são itens
 * diferentes), igual à do resto da tela.
 */
export function splitEntries(raw: string): string[] {
  const seen = new Set<string>();
  const entries: string[] = [];
  for (const part of raw.split(';')) {
    const entry = part.trim();
    if (!entry || seen.has(entry)) continue;
    seen.add(entry);
    entries.push(entry);
  }
  return entries;
}

/** Texto de ajuda dos campos que aceitam vários itens. Uma constante só,
 *  pra a frase não divergir de campo pra campo. */
export const MULTI_ENTRY_HINT =
  'Para adicionar vários de uma vez, separe por ponto e vírgula (;).';
